import React, { useState, useEffect } from 'react';
import CustomFields from './CustomFields';
import Loader from './Loader';
import { toast } from 'react-toastify';
import ApiService from '../services/ApiService';

const CustomFieldsModal = ({ isOpen, onClose, subCategoryId, subCategoryTitle, initialFields = [], onSave }) => {
  const [fields, setFields] = useState(initialFields || []);
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setFields(initialFields || []);
    }
  }, [isOpen, initialFields]);

  const handleFieldsChange = (updatedFields) => {
    setFields(updatedFields);
  };

  const handleSave = async () => {
    setIsSaving(true);
    try {
      console.log('Saving fields for subcategory:', subCategoryId, fields);
      const response = await ApiService.request({
        method: 'POST',
        url: `categories/subcategory/${subCategoryId}/fields`,
        data: {
          fields: fields
        },
      });

      console.log('Save response:', response.data);

      if (response.data.status) {
        toast.success(response.data.message || 'Custom fields saved successfully!');
        if (onSave) {
          // Pass the fields from the response if available, otherwise use local state
          const savedFields = response.data.data?.fields || fields;
          onSave(subCategoryId, savedFields);
        }
        onClose();
      } else {
        toast.error(response.data.message || 'Failed to save custom fields');
      }
    } catch (error) {
      console.error('Error saving custom fields:', error);
      toast.error('Failed to save custom fields');
    } finally {
      setIsSaving(false);
    }
  };

  if (!isOpen) return null;

  return (
    <>
      <div className="modal-backdrop fade show" onClick={onClose}></div>
      <div 
        className="modal fade show d-block" 
        style={{ display: 'block' }}
        tabIndex="-1"
        role="dialog"
      >
        <div className="modal-dialog modal-xl modal-dialog-centered">
          <div className="modal-content ">
            <div className="modal-header">
              <h5 className="modal-title">
                Custom Fields - {subCategoryTitle}
              </h5>
              <button 
                type="button" 
                className="btn-close" 
                onClick={onClose}
                disabled={isSaving}
              ></button>
            </div>
            <div className="modal-body">
              <CustomFields 
                fields={fields} 
                onChange={handleFieldsChange} 
              />
            </div>
            <div className="modal-footer">
              <button 
                type="button" 
                className="btn btn-light" 
                onClick={onClose}
                disabled={isSaving}
              >
                Cancel
              </button>
              <button 
                type="button" 
                className="btn btn-base" 
                onClick={handleSave}
                disabled={isSaving}
              >
                {isSaving ? <Loader size="20" color="white" text="Saving" /> : 'Save Fields'}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CustomFieldsModal;

